import posthog from 'posthog-js';

const track = (event, props = {}) => {
  try {
    if (posthog.__loaded) posthog.capture(event, props);
  } catch (_) {
    // PostHog not initialised — safe to ignore
  }
};

export const trackGenerationStarted   = (props = {}) => track('generation_started',   props);
export const trackGenerationCompleted = (props = {}) => track('generation_completed', props);
export const trackGenerationFailed    = (props = {}) => track('generation_failed',    props);
export const trackUpgradeClicked      = (props = {}) => track('upgrade_clicked',      props);
export const trackCheckoutCompleted   = (props = {}) => track('checkout_completed',   props);
export const trackReferralShared      = (props = {}) => track('referral_shared',      props);
export const trackCodeExported        = (props = {}) => track('code_exported',        props);
export const trackTemplateUsed        = (props = {}) => track('template_used',        props);
